import React, { Component } from "react";
import ReactDOM from 'react-dom';

export default class CheckBox extends Component{
    constructor() {
      super();
      this.state = {isChecked: false};
      this.handleChecked = this.handleChecked.bind(this); // set this, because you need get methods from CheckBox
    }

    handleChecked () {
      this.setState({isChecked: !this.state.isChecked});
    }

    render(){
      var txt;
      var txt2;
      if (this.state.isChecked) {
        txt = <button type="submit" className="btn btn-success btn-block btn-color">Service Type</button>
        txt2 = <button type="submit" className="btn btn-success btn-block btn-color">Hourly charges</button>
      }

      return <div>
         <input type="checkbox" onChange={ this.handleChecked }/>
         <label htmlFor="checkBox"> Signup as service personnel?</label>
          <p>{txt}{txt2}</p>
      </div>
    }
  }

  ReactDOM.render(
    <CheckBox/>,
    document.getElementById('root')
  );
